<template>
<div class="slide-results">
    <div class="loading__container" v-if="loading">
        <h4>Loading cooker information</h4>
    </div>
    <div v-else>
        <div class="page__header">
            <div class="search-question" data-step="5">
                <template v-if="cookerList.length != 1">{{cookerList.length}} cookers match your requirements</template>
                <template v-else>1 cooker matches your requirements</template>
            </div>
        </div>
        <div class="page__content">
            <div class="page__wrap" v-if="cookerList.length > 2">
                <div class="slider__wrap">
                    <swiper :options="swiperOption" class="cooker-flow" ref="mySwiper">
                        <swiper-slide v-for="cooker in cookerList" :key="cooker.id" class="cooker-flow__entry">
                            <img :src="cooker.variations[0].img"  @click="openCooker(cooker.id)"/>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </div>
                <div class="swiper-pagination" slot="pagination"></div>
                <h3 class="swiper__h3" @click="openCooker(cookerList[currentSlide].id)">{{ cookerList[currentSlide].attributes.productName }}</h3>
            </div>
            <div class="page__wrap single__results" v-else>
                <div v-for="cooker in cookerList" :key="cooker.id"  @click="openCooker(cooker.id)">
                    <img :src="cooker.variations[0].img" />
                    <h3>{{ cooker.attributes.productName }}</h3>
                </div>
            </div>
        </div>
    </div>
    
</div>
</template>

<script>
import {getDatabase} from '../../api/index';
export default {
    data: function(){
        return {
            loading: true,
            cookerList: [],
            currentSlide: 0,
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 60,
                centeredSlides: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 10
                    },
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    }
                },
                on: {
                    slideChange: ()=>{
                        this.currentSlide = this.$refs.mySwiper.swiper.activeIndex;
                    }
                }
            }
        }
    },
    watch: {
        '$route.params': function(){
            this.search();
        }
    },
    methods: {
        search(){
            this.loading = true;
            getDatabase().query(this.$route.params).then(c =>{
                this.cookerList = c;
                this.loading = false;
            })
            // this.cookerList = cookers;
            
        },
        openCooker(id){
            this.$ga.event('select', 'cooker', this.cookerList.find( ({id: cookerId}) => id == cookerId ).attributes.productName );
            this.$router.push({ name: 'cooker', params: {...this.$route.params, cooker: id } })
        }
    },
    mounted: function(){
        //Grok cookers from backend
        // this.$route.params
        this.search();
        this.$ga.screenview('results');
    
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/slide-5-results.vue